// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.captchaContainer {
  display: flex;
  align-items: center;
}

.retryButton {
  border: none;
  margin: 0 0 0 16px;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  outline: none;
  text-align: inherit;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-client-captcha/dist/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".captchaContainer {\n  display: flex;\n  align-items: center;\n}\n\n.retryButton {\n  border: none;\n  margin: 0 0 0 16px;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n  -webkit-appearance: none;\n  outline: none;\n  text-align: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
